export const OFFSHORE_REPORT_STORE_ID = 'OffshoreReportStore';
